import classNames from 'classnames';
import Image from 'next/image';
import { memo } from 'react';

import { FileExtensionPreview, ImageContainer } from '@air/component-file-extension-preview';
import { ImgixImage } from '@air/component-imgix-image';
import { type UploadStatus } from '@air/redux-uploader';

import { SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES } from '../../constants/ClassNames';
import { FileStatusFolderStatus } from './FileStatusFolderStatus';

export type FileStatusThumbnailProps = {
  ext?: string;
  status: UploadStatus;
  thumbnailSource?: string;
};

const isLocalThumbnailSrc = (src: string): boolean => src.startsWith('data:') || src.startsWith('blob:');

export const FileStatusThumbnail = memo(({ ext = '', status, thumbnailSource }: FileStatusThumbnailProps) => {
  if (thumbnailSource) {
    const thumbnailProps = {
      alt: '',
      className: 'mr-3 inline-block size-10 shrink-0 rounded-4 object-cover',
      height: 40,
      src: thumbnailSource,
      width: 40,
    };

    if (isLocalThumbnailSrc(thumbnailSource)) {
      return <Image {...thumbnailProps} />;
    }

    return <ImgixImage {...thumbnailProps} />;
  }

  if (ext === 'folder') {
    return <FileStatusFolderStatus status={status} />;
  }

  return (
    <ImageContainer
      borderRadius={2}
      className={classNames(SHARED_PANEL_ITEM_THUMBNAIL_CLASS_NAMES, '!grow-0 rounded-4')}
      ext={ext}
      processing={false}
    >
      <div className="flex h-full items-center justify-center">
        <FileExtensionPreview className="max-w-[40px]" ext={ext} size="small" />
      </div>
    </ImageContainer>
  );
});

FileStatusThumbnail.displayName = 'FileStatusThumbnail';
